<script lang="ts">
    export let prevProject: { title: string; url: string };
    export let nextProject: { title: string; url: string };
    import { reveal } from 'svelte-reveal';
</script>

<nav class="border-t border-gray-100" use:reveal={{ blur: 10 }}>
    <div class="container mx-auto px-4 md:px-8">
        <div class="flex justify-between -mt-px">
            <a href={prevProject.url} 
               class="w-1/2 group py-6 pr-2 flex items-center border-t-2 border-transparent hover:border-[#F96604] transition-colors">
                <div class="flex items-center text-gray-500 group-hover:text-[#F96604]">
                    <svg class="w-3 h-3 sm:w-4 sm:h-4 mr-2 transition-transform group-hover:-translate-x-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 8H1M1 8L8 15M1 8L8 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div>
                        <div class="text-xs uppercase tracking-wider mb-1">Previous</div>
                        <div class="font-light">{prevProject.title}</div>
                    </div>
                </div>
            </a>
            
            <a href={nextProject.url} 
               class="w-1/2 group py-6 pl-2 flex items-center justify-end border-t-2 border-transparent hover:border-[#F96604] transition-colors">
                <div class="flex items-center text-right text-gray-500 group-hover:text-[#F96604]">
                    <div>
                        <div class="text-xs uppercase tracking-wider mb-1">Next</div>
                        <div class="font-light">{nextProject.title}</div>
                    </div>
                    <svg class="w-3 h-3 sm:w-4 sm:h-4 ml-2 transition-transform group-hover:translate-x-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 8H15M15 8L8 1M15 8L8 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </a>
        </div>
    </div>
</nav> 